import * as _ from 'lodash';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormControlBase } from './form-control-base';
import { FormDoubleDropdownControlData } from './form-control-data';

export class DropdownDoubleControl extends FormControlBase<any> {
  controlType = 'dropdown-double';

  rightKey: string;
  rightPlaceholder: string;
  _rightValue: string = '';
  _leftValue: string = '';
  idValue: any = undefined;
  rightFormControl: FormControl;
  rightDropdownOptions: any;
  onChange = new Subject();

  get leftValue(): any { return this._leftValue; }
  set leftValue(value: any) {
    const isChanged = value !== this._leftValue;
    this._leftValue = value;
    if (isChanged) {
      this.leftOnChange(value);
    }
  };
  get rightValue(): any { return this._rightValue; }
  set rightValue(value: any) {
    const isChanged = value !== this._rightValue;
    this._rightValue = value;
    this.rightFormControl.setValue(value);
  };

  constructor(options: FormDoubleDropdownControlData<any>) {
    super(options);
    this.rightKey = options.rightKey;
    this.rightPlaceholder = options.rightPlaceholder;
  }

  protected initialize() {
  }
  commit() {
  }
  setFormControl(formControl: FormControl, group?: FormGroup) {
    this.formControl = formControl;
    this.setValidators();
    this.rightFormControl = new FormControl({ value: this.rightValue, disabled: this.disabled } || '');
    if (group) {
      group.addControl(this.rightKey, this.rightFormControl);
    }
  }

  get disabled() { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = value;
    if (this.formControl) {
      this._disabled ? this.formControl.disable() : this.formControl.enable();
    }
    if (this.rightFormControl) {
      this._disabled ? this.rightFormControl.disable() : this.rightFormControl.enable();
    }
  };

  leftOnChange(value: any) {
    let retValue = {};
    this.idValue = undefined;
    if (!this.options) {
      return;
    }
    const chosenItem = _.find(this.options, it => it.key === value);
    if (chosenItem) {
      retValue = chosenItem;
      this._rightValue = chosenItem.key;
      this.idValue = chosenItem.key;
    } else {
      this._rightValue = null;
      this.idValue = null;
    }
    this.onChange.next(retValue);
  };

  rightOnChange(value: any) {
    let retValue = {};
    this.idValue = undefined;
    if (!this.options) {
      return;
    }
    const chosenItem = _.find(this.options, it => it.key === value);
    if (chosenItem) {
      retValue = chosenItem;
      this._leftValue = chosenItem.key;
      this.idValue = chosenItem.key;
      this.formControl.setValue(value);
    } else {
      this._leftValue = null;
      this.idValue = null;
    }
    this.onChange.next(retValue);
  };
}
